var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioPetSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5698 26.9605C35.9744 22.9117 31.5542 20.4941 26.7455 20.4941C21.9368 20.4941 17.5166 22.9117 14.9217 26.9605L8.66786 36.7166C7.63025 38.335 7.15148 40.2052 7.28306 42.1233C7.41463 44.0419 8.14465 45.8284 9.39392 47.2911C10.6441 48.7525 12.296 49.7514 14.171 50.18C16.046 50.6086 17.9681 50.4255 19.7291 49.6515L19.847 49.5991C24.2782 47.6902 29.3417 47.7078 33.7615 49.6515C34.9016 50.1527 36.1095 50.4062 37.3284 50.4062C37.9911 50.4062 38.6578 50.3309 39.3183 50.1804C41.1933 49.7523 42.8452 48.7534 44.0957 47.2916C45.3455 45.8302 46.0759 44.0432 46.2079 42.1242C46.3399 40.2052 45.8612 38.3355 44.8236 36.7161L38.5698 26.9605Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3519 26.9483C12.2124 26.2337 13.6258 24.7345 14.3316 22.7266C15.0036 20.816 14.9486 18.6589 14.1763 16.6523C13.4036 14.6471 11.9981 13.0101 10.2186 12.0425C8.34933 11.0264 6.29567 10.861 4.43827 11.5769C0.701468 13.0136 -1.01336 17.6314 0.6161 21.8729C1.91773 25.2489 4.95355 27.38 8.02282 27.38C8.80653 27.38 9.59243 27.2409 10.3519 26.9483Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4868 19.3067C27.1582 19.3067 30.9588 14.9767 30.9588 9.65443C30.9588 4.33085 27.1582 0 22.4868 0C17.8158 0 14.0156 4.33085 14.0156 9.65443C14.0156 14.9767 17.8158 19.3067 22.4868 19.3067Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1169 21.6788H37.1173C37.8359 21.9173 38.569 22.0313 39.299 22.0313C42.7058 22.0313 46.0259 19.5516 47.2928 15.7409C48.0223 13.5473 47.9744 11.2279 47.1577 9.21031C46.3031 7.09813 44.7194 5.56504 42.6979 4.8931C40.6759 4.22116 38.4894 4.50146 36.5404 5.68165C34.6786 6.80902 33.252 8.63826 32.5233 10.8318C30.9854 15.4593 33.0461 20.3252 37.1169 21.6788V21.6788Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9613 20.549L54.9599 20.5476C51.7384 18.1679 46.9205 19.1994 44.2191 22.8482C41.5203 26.4987 41.9423 31.4065 45.159 33.7879C46.3321 34.657 47.7182 35.0724 49.1369 35.0724C51.6095 35.0724 54.182 33.8104 55.9016 31.4896C58.5999 27.8391 58.1784 22.9313 54.9613 20.549V20.549Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.65868,
    y1: 27.0141,
    x2: 48.3202,
    y2: 37.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.910272,
    y1: 14.6788,
    x2: 16.0961,
    y2: 17.4775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.0578,
    y1: 4.2083,
    x2: 32.486,
    y2: 7.30192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 32.9851,
    y1: 8.34881,
    x2: 49.2019,
    y2: 11.3097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 43.3787,
    y1: 22.7118,
    x2: 58.9541,
    y2: 25.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioPetSelected);
export default __webpack_public_path__ + "static/media/radioPet_selected.afc4dd6c4429d6e1367023a28ceed7e7.svg";
export { ForwardRef as ReactComponent };